import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';

import { toBoolean } from 'root/apps/pages/utils/sanitize';

const LOCAL_STORAGE_REMOVED_ITEM_SERIAL_ID_KEY = 'removedItemSerialID';

export interface SerialsAutocompleteOption extends AutocompleteOption {
  serial: string;
  colorName: string;
  sizeName: string;
}

export const searchSerials = async ({ query = '', itemId }: { query: string; itemId: string }) => {
  const response = await fetch(
    `/API/V3/Account/${window.merchantos.account.id}/Serialized.json?serial=~,${query}%&limit=250&sort=-serializedID&customerID=0&itemID=${itemId}&load_relations=["SaleLine.Sale"]`
  );

  let apiSerials: SerialFromAPI[] = [];
  let serials: SerialsAutocompleteOption[] = [];
  try {
    ({ Serialized: apiSerials } = await response.json());

    if (apiSerials && !(apiSerials instanceof Array)) {
      apiSerials = [apiSerials];
    }

    serials = apiSerials
      .filter((serial) => !toBoolean(serial?.SaleLine?.Sale?.completed))
      .map((item) => {
        const { serial, colorName, sizeName, serializedID } = item;

        return {
          serial,
          colorName,
          sizeName,
          value: serializedID,
          label: serial,
        };
      });

    serials = orderBy(serials, ['serial'], ['asc']);
  } catch (err) {
    // Error parsing the API response
  }

  return serials;
};

export const getMountProps = (filters: HistoryFilter) => {
  if (filters.pathname === '/register.php') {
    return {
      hiddenInput: {
        name: 'serialized_id',
      },
      hasSubmitFormButton: true,
    };
  }

  if (filters.name === 'ship_to.views.ship_to') {
    return {
      onChange: 'listingAssignItemSerial',
      panelId: document.getElementById('ship_to_listings_transaction_lines_view'),
      preventViewFieldChanged: true,
    };
  }

  return {};
};

export const removeLineItemSerializedInfoFromStorage = (transactionLineId: number) => {
  const storedValue = localStorage.getItem(LOCAL_STORAGE_REMOVED_ITEM_SERIAL_ID_KEY);
  if (storedValue === null) {
    return;
  }

  const serialInfo = JSON.parse(storedValue);
  if (!(transactionLineId in serialInfo)) {
    return;
  }

  delete serialInfo[transactionLineId];

  if (isEmpty(serialInfo)) {
    localStorage.removeItem(LOCAL_STORAGE_REMOVED_ITEM_SERIAL_ID_KEY);
    return;
  }

  localStorage.setItem(LOCAL_STORAGE_REMOVED_ITEM_SERIAL_ID_KEY, JSON.stringify(serialInfo));
};

export const reinstateSerialOnTransactionLine = (
  transactionLineId: number,
  panelId: PanelId,
  customerId: string
) => {
  const storedValue = localStorage.getItem(LOCAL_STORAGE_REMOVED_ITEM_SERIAL_ID_KEY);
  if (storedValue === null) {
    return;
  }

  const serialInfo = JSON.parse(storedValue);
  if (!(transactionLineId in serialInfo)) {
    return;
  }

  const serialId = serialInfo[transactionLineId];
  window.listingAssignItemSerial(panelId, transactionLineId, customerId, serialId, true);

  removeLineItemSerializedInfoFromStorage(transactionLineId as number);
};
